import store from '../state/store/store';
import { PRODUCT_TYPES } from "./consts";
import {IMPRESSION_PER_PAGEVIEW, VIDEO_COMPLETION_RATE} from "../pages/dashboard/monetization/consts";

// CHART SETTINGS
export const CHART_SETTINGS = {
    numOfTicksAllowed: 53,
    dailyRollupThreshold: 180,
    linePropsForTimeScale: (dateLength) => {
        return {
            xScale:{
                format: '%Y-%m-%d',
                precision: 'day',
                type: 'time',
                useUTC: false
            },
            axisBottom: {
                orient: 'bottom',
                tickSize: 0,
                tickPadding: 20,
                tickRotation: (dateLength <= 10 ? 0 : 60),
                format: '%b %d',
                tickValues: dateLength < 60 ? dateLength : 'every 5 days'
            },
            margin: {
                top: 10,
                right: 25,
                left: 80,
                bottom: 60
            }
        }
    },
    linePropsDefualt: (dateLength) => {
        return {
            axisBottom: {
                orient: 'bottom',
                tickSize: 0,
                tickPadding: 20,
                format: (s) => String(s),
                tickRotation: (dateLength <= 10 ? 0 : 60),
                tickValues: dateLength <= 5 ? dateLength : 5
            },
            margin: {
                top: 10,
                right: 35,
                left: 80,
                bottom: dateLength <= 10 ? 50 : 60
            }
        }
    }
}

export const processDataForAxis = (dataArr) => {
    return dataArr.map(d => {
        return {
            ...d,
            data: d.data.map((item, index) => {
                return { ...item, x: item.origDate || item.originalDate }; // Replace x with empty string
            })
        };
    })
}


export const countNoOfDecimalPlaces = (value) =>
{
    return (String(value).includes('.') ? String(value).split('.')[1].length : 0);//if a string has . , count the decimal places after it
}

export const checkAndLimitMinimumFractionDigits = (value) =>
{
    return (value>=1 && value<=20) ? value : (value>20 ? 20 : 1) //check min limits, minimum limit should be between 1 and 20
}

export const checkAndLimitMaximumFractionDigits = (value) =>
{
    return (value>=1 && value<=20) ? value : (value>20? 20 : 1) //check max limits, max limit should be between 1 and 21
}

// this is non-sustainable. Specially with more demand for customization. It should accept params as object.
//Example: formatNumber = (value, formatPops = {}) => {}
export const formatNumber = (value, metricType, noSpace=false) => {
    if(isNaN(value)) value = 0;
    if(metricType === 'percentage'){
        return `${Number(value * 100).toLocaleString('en-US', {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1
        })}${noSpace ? '' : ' '}%`
    } else if(metricType === 'percent'){
        return `${Number(value).toLocaleString('en-US', {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1
        })}${noSpace ? '' : ' '}%`
    } else if(metricType === 'dollar'){
        const decimalPoints = 2; //always display dollar with rounding off to 2 decimal places in dashboard view
        return `$${Number(value).toLocaleString('en-US', {
            minimumFractionDigits: decimalPoints,
            maximumFractionDigits: decimalPoints
        })}`
    } else {
        let maximumFractionDigits;
        if(metricType === 'number'){
            maximumFractionDigits = 1;
        }
        else {
            // This is default fraction digit. Temporary retaining the value to see if it needs to be modified or removed in future
            maximumFractionDigits = 2;
        }
        return `${Number(value).toLocaleString('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits
        })}`
    }
}

export const formatNumberNoRoundingOff = (value, metricType, noSpace=false) => {
    if(isNaN(value)) value = 0;
    const minDecimalPoints = checkAndLimitMinimumFractionDigits(countNoOfDecimalPlaces(value))
    const maxDecimalPoints = checkAndLimitMaximumFractionDigits(countNoOfDecimalPlaces(value))
    if(metricType === 'percentage'){
        const minDecimalPointsPercentage = checkAndLimitMinimumFractionDigits(countNoOfDecimalPlaces(value*100))
        const maxDecimalPointsPercentage = checkAndLimitMaximumFractionDigits(countNoOfDecimalPlaces(value*100))
        return `${Number(value * 100).toLocaleString('en-US', {
            minimumFractionDigits: minDecimalPointsPercentage,
            maximumFractionDigits: maxDecimalPointsPercentage
        })}${noSpace ? '' : ' '}%`
    } else if(metricType === 'percent'){
        return `${Number(value).toLocaleString('en-US', {
            minimumFractionDigits: minDecimalPoints,//count no of decimal places for percentage,
            maximumFractionDigits: maxDecimalPoints,//count no of decimal places for percentage
        })}${noSpace ? '' : ' '}%`
    } else if(metricType === 'dollar'){
        return `$${Number(value).toLocaleString('en-US', {
            minimumFractionDigits: minDecimalPoints,
            maximumFractionDigits: maxDecimalPoints
        })}`
    } else {
        return `${Number(value).toLocaleString('en-US', {
            minimumFractionDigits: minDecimalPoints,
            maximumFractionDigits: maxDecimalPoints
        })}`
    }
}

export const formatNumberToHoursMins = num => {
    const mins = Math.floor(num / 60);
    const secs = parseInt(num % 60);
    let formattedTime = '';

    if(mins > 60) {
        const hours = Math.floor(mins / 60);
        const min = parseInt(mins % 60);
        const formattedHours = hours > 0 ? `${hours}h ` : '';
        const formattedMins = min > 0 ? `${min < 10 ? `0${min}` : min}m` : '';
        formattedTime = `${formattedHours}${formattedMins}`;
    } else {
        const formattedMins = mins > 0 ? `${mins}m ` : '';
        const formattedSecs = secs > 0 ? `${secs < 10 ? `0${secs}` : secs}s` : '';
        formattedTime = `${formattedMins}${formattedSecs}`;
    }
 
    return formattedTime;
}

export const getChangeRateDirection = rate => {
    return rate < 0 ? 'down' : 'up';
}

export const getChartCardRateDirection = rate => {
    return rate < 0 ? 'negative' : 'positive';
}

export const formatChartCardData = (details, dataType) => {
    const detailsTotalData = details.TOTAL.Daily.TOTAL;
    let chartData = [{"id": dataType, "color": "rgb(20, 148, 244)", data: []}];
    Object.keys(detailsTotalData).forEach(date => chartData[0].data.push({"x": date, "y": detailsTotalData[date][dataType]}));
    return chartData;
}

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const fullNameMonths = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const quarterMonths = ['Jan-Mar', 'Apr-Jun', 'Jul-Sep', 'Oct-Dec'];


export const formatTooltipDate = (date, period, startDate = null, endDate = null) => {
    let formattedDate = date;
    if(date) {
        const dateArr = date.split('-');
        const year = dateArr[0];
        const month = months[dateArr[1] - 1];
        const formattedPeriod = period ? period.toLowerCase() : '';
        switch(formattedPeriod) {
            case 'daily':
                formattedDate = `${month} ${parseInt(dateArr[2], 10)}, ${year}`;
                break;
            case 'weekly':
                let rangeDate = '';
                if(startDate && endDate) {
                    const startMonth = months[startDate.split('-')[1] - 1];
                    const startDay = parseInt(startDate.split('-')[2], 10);
                    const startYear = parseInt(startDate.split('-')[0]);
                    const endMonth = months[endDate.split('-')[1] - 1 ];
                    const endDay = parseInt(endDate.split('-')[2], 10);
                    const endYear = parseInt(endDate.split('-')[0]);
                    const isSameYear = startYear === endYear;
                    if(startMonth === endMonth) {
                        rangeDate = `${startMonth} ${startDay}-${endDay}, ${startYear}`;
                    } else {
                        rangeDate = `${startMonth} ${startDay}${!isSameYear ? `, ${startYear}` : ''} - ${endMonth} ${endDay}, ${endYear}`; 
                    }
                }
                formattedDate = `Wk ${dateArr[1]}, ${rangeDate}`;
                break;
            case 'monthly':
                formattedDate = `${month}, ${year}`;
                break;
            case 'quarterly':
                const quarterNo = dateArr[1];
                formattedDate = `Q${quarterNo}, ${quarterMonths[quarterNo - 1]}, ${year}`;
                break;
            default:
                break;
        }
    }
    return formattedDate;
}

export const formatXAxisDates = (date, period, dateLength = 0, maxCount = 10, formatted = false) => {
    let formattedDate = date;
    if(date) {
        const dateArr = date.split('-');
        const year = dateArr[0];
        const shortcutYear = dateArr[0].toString().substr(-2);
        const month = months[dateArr[1] - 1];
        const formattedPeriod = period ? period.toLowerCase() : '';
        switch(formattedPeriod) {
            case 'daily':
                formattedDate = `${month} ${dateArr[2]}`
                break;
            case 'weekly':
                const wkNo = dateArr[1] < 10 ? `0${dateArr[1]}` : dateArr[1];
                formattedDate = dateLength < maxCount ? `Wk ${wkNo} ${year}` : `Wk ${wkNo}`;
                break;
            case 'monthly':
                formattedDate = dateLength < maxCount ? `${month} ${year}` : `${month} ${shortcutYear}`;
                break;
            case 'quarterly':
                formattedDate = dateLength < maxCount ? `Q${dateArr[1]} ${year}` : `Q${dateArr[1]} ${shortcutYear}`;
                break;
            default:
                break;
        }
    }
    return formattedDate;
}

export const formatTableDate = (date, period, startDate = null, endDate = null) => {
    let formattedDate = date;
    if(date) {
        const dateArr = date.split('-');
        const year = dateArr[0];
        let month = fullNameMonths[dateArr[1] - 1];
        const formattedPeriod = period ? period.toLowerCase() : '';
        switch(formattedPeriod) {
            case 'daily':
                month = month.substring(0,3);
                formattedDate = `${month} ${parseInt(dateArr[2], 10)}, ${year}`;
                break;
            case 'weekly':
                let rangeDate = '';
                if(startDate && endDate) {
                    const startMonth = fullNameMonths[startDate.split('-')[1] - 1].substring(0,3);
                    const startDay = parseInt(startDate.split('-')[2], 10);
                    const startYear = parseInt(startDate.split('-')[0]);
                    const endMonth = fullNameMonths[endDate.split('-')[1] - 1 ].substring(0,3);
                    const endDay = parseInt(endDate.split('-')[2], 10);
                    const endYear = parseInt(endDate.split('-')[0]);
                    const isSameYear = startYear === endYear;
                    if(startMonth === endMonth) {
                        rangeDate = `${startMonth} ${startDay}-${endDay}, ${startYear}`;
                    } else {
                        rangeDate = `${startMonth} ${startDay}${!isSameYear ? `, ${startYear}` : ''} - ${endMonth} ${endDay}, ${endYear}`; 
                    }
                }
                formattedDate = `Week ${dateArr[1]}: ${rangeDate}`;
                break;
            case 'monthly':
                formattedDate = `${month} ${year}`;
                break;
            case 'quarterly':
                const quarterMonths = ['Jan-Mar', 'Apr-Jun', 'Jul-Sep', 'Oct-Dec'];
                const quarterNo = dateArr[1];
                formattedDate = `Q${quarterNo} ${year}: ${quarterMonths[quarterNo - 1]} ${year}`;
                break;
            default:
                break;
        }
    }
    return formattedDate;
}


export const getProductDetails = productId => {
    const products = [...PRODUCT_TYPES];

    const product = products.filter(product => productId === product.id);
    return product && product.length === 1 ? product[0] : null;
}

// TODO: Update this when adding new product
export const getProducts = () => {
    const products = [...PRODUCT_TYPES];
    return products;
}

export const sortMetricData = (data, total) => {
    const sortedData = Object.entries(total).sort((a, b) => b[1].data - a[1].data).map(d => d[0]);
    let productList = {};
    sortedData.forEach(id => {
        if(Object.keys(data[id]).length > 0) productList[id] = data[id];
    })

    if (data.OTHERS) {
        delete productList.OTHERS;
        productList.OTHERS = data.OTHERS;
    }

    delete productList.TOTAL;
    productList.TOTAL = data.TOTAL;

    if (data[IMPRESSION_PER_PAGEVIEW]) {
        delete productList[IMPRESSION_PER_PAGEVIEW];    
        productList[IMPRESSION_PER_PAGEVIEW] = data[IMPRESSION_PER_PAGEVIEW];
    }

    if (data[VIDEO_COMPLETION_RATE]) {
        delete productList[VIDEO_COMPLETION_RATE];
        productList[VIDEO_COMPLETION_RATE] = data[VIDEO_COMPLETION_RATE];
    }
    return productList;
}

export const reorderProductsData = (products, order = 'ASC') => {
    let productList = {};
    Object.keys(products).forEach(id => {
        if(Object.keys(products[id]).length > 0) productList[id] = products[id];
    })
    delete productList.TOTAL;
    productList.TOTAL = products.TOTAL;
    return productList;
}

const globalCalendarDaysDiff = () => {
    const state = store.getState();
	const startDate = new Date(state.app.filters.dateRange.from);
    const endDate = new Date(state.app.filters.dateRange.to);
    if(startDate && endDate)
        return Math.round((endDate-startDate)/(1000*60*60*24)) + 1;
    else
        return 31;
}

const globalCalendarQuarters = () => {
    const state = store.getState();
	const startDate = state.app.filters.dateRange.from;
    const endDate = state.app.filters.dateRange.to;
    let numQuarters = 0;

    if(startDate && endDate) {
        const startYear = parseInt(startDate.split('-')[0]);
        const endYear = parseInt(endDate.split('-')[0]);
        const startMonth = parseInt(startDate.split('-')[1]);
        const endMonth = parseInt(endDate.split('-')[1]);

        const years = endYear - startYear;

        if(years === 0) {
            const startQuarter =  Math.ceil(startMonth / 3);
            const endQuarter =  Math.ceil(endMonth / 3);
            numQuarters = (endQuarter - startQuarter) + 1;
        } else {
            const startQuarter =  Math.ceil(startMonth / 3);
            const endQuarter =  Math.ceil(endMonth / 3);
            for(var i = startYear; i <= endYear; i++) {
                if(i === startYear) numQuarters += (4 - startQuarter) + 1;
                else if(i === endYear) numQuarters += endQuarter;
                else numQuarters += 4
            }
        }
    }

    return numQuarters;
}


export const getEnabledRollUps = () => {
    const enabledRollups = [];
    ['daily', 'weekly', 'monthly', 'quarterly'].forEach(period => {
        switch(period) {
            case 'daily':
                if(globalCalendarDaysDiff() <= CHART_SETTINGS.dailyRollupThreshold)
                    enabledRollups.push('daily');
                break;
            case 'weekly': 
                if((globalCalendarDaysDiff() / 7) <= (366 / 7))
                    enabledRollups.push('weekly');
                break;
            case 'monthly':
                if(Math.ceil(globalCalendarDaysDiff() / 30.417) <= 48)
                    enabledRollups.push('monthly');
                break;
            case 'quarterly':
                if(globalCalendarQuarters() <= 20)
                    enabledRollups.push('quarterly');
                break;
        }
    })
    let orderedRollups = ['daily', 'weekly', 'monthly', 'quarterly'];
    orderedRollups = orderedRollups.filter(rollup => enabledRollups.indexOf(rollup) >= 0);
    return orderedRollups;
}

// As of now we just have dollar and other type is empty. In future, if more variation is needed. 
// Please consider this requirement, where we dont want to show x.yy [decimal] part with Y axis
export const formatYAxis = (amount, dataType) => {
    const amountStr = amount.toLocaleString();
    const amountCommaLength = amountStr.match(/,/g) ? amountStr.match(/,/g).length : 0;
    let formattedYAxis;
    if(amountCommaLength === 0 && dataType !== 'dollar'){
        formattedYAxis = amount.toFixed(0);
    }
    else {
        formattedYAxis = amount.toFixed(amount < 100 ? 2 : 0);
    }
    if(amountCommaLength > 0) {
        const preCommaDigits = parseInt(amountStr.split(",")[0]);
        const postCommaDigit = parseInt(amountStr[amountStr.indexOf(',') + 1]);
        const roundedPostCommaDigit = amountStr[amountStr.indexOf(',') + 2] >= 5 ? postCommaDigit + 1 : postCommaDigit;
        const units = ["K", "M", "B"];
        units.forEach((postFix, index) => formattedYAxis = amountCommaLength === (index + 1) ? `${preCommaDigits}.${roundedPostCommaDigit}${postFix}` : formattedYAxis);
    }
    formattedYAxis = dataType === "dollar" ? `$${formattedYAxis}` : formattedYAxis;
    if (dataType === "percentage") formattedYAxis = formattedYAxis + "%";
    return formattedYAxis;
}


export const downloadCSV = (content, fileName, mimeType) => {
    var a = document.createElement('a');
    mimeType = mimeType || 'application/octet-stream';
  
    if (navigator.msSaveBlob) { // IE10
        navigator.msSaveBlob(new Blob([content], {type: mimeType}), fileName);
    } else if (URL && 'download' in a) { 
        a.href = URL.createObjectURL(new Blob([content], {
            type: mimeType
        }));
        a.setAttribute('download', fileName);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    } else {
        window.location.href = 'data:application/octet-stream,' + encodeURIComponent(content); // only this mime type is supported
    }
}


export const formatDataLabels = value => {
    let formattedValue = value.toFixed(value < 100 ? 1 : 0);
    const valueStr = value.toLocaleString();
    const valueCommaLength = valueStr.match(/,/g) ? valueStr.match(/,/g).length : 0;

    if(valueCommaLength > 0) {
        const preCommaDigits = parseInt(valueStr.split(",")[0]);
        const postCommaDigit = parseInt(valueStr[valueStr.indexOf(',') + 1]);
        const roundedPostCommaDigit = valueStr[valueStr.indexOf(',') + 2] >= 5 ? postCommaDigit + 1 : postCommaDigit;
        const units = ["K", "M", "B"];
        units.forEach((postFix, index) => formattedValue = valueCommaLength === (index + 1) ? `${preCommaDigits}.${roundedPostCommaDigit}${postFix}` : formattedValue);
    }
    formattedValue = !formattedValue.toString().includes('.') ? `${formattedValue}` : formattedValue;

    return formattedValue;
}

export const formatProductAnalyticsReportDates = (date, period, dateLength = 0, maxCount = 10, formatted = false) => {
    let formattedDate = date;
    if(date) {
        let dateArr = date.split('');
        const year = date.substr(0, 4);
        const shortcutYear = year.substr(-2);
        let month = '';
        const formattedPeriod = period ? period.toLowerCase() : '';
        switch(formattedPeriod) {
            case 'daily':
                dateArr = date.split('-');
                month = months[dateArr[1] - 1] ? months[dateArr[1] - 1] : '';
                const day = dateArr[2] ? dateArr[2] : '';
                formattedDate = `${month} ${day}`;
                break;
            case 'weekly':
                dateArr = date.split(' ');
                const week = dateArr[2] ? dateArr[2] : '';
                formattedDate = dateLength < maxCount ? `Wk ${week} ${year}` : `Wk ${week}`;
                break;
            case 'monthly':
                dateArr = date.split('-');
                month = months[dateArr[1] - 1] ? months[dateArr[1] - 1] : '';
                formattedDate = dateLength < maxCount ? `${month} ${year}` : `${month} ${shortcutYear}`;
                break;
            case 'quarterly':
                dateArr = date.split(' ');
                const quarter = dateArr[1] ? dateArr[1] : '';
                formattedDate = dateLength < maxCount ? `${quarter} ${year}` : `${quarter} ${shortcutYear}`;
                break;
            default:
                break;
        }
    }
    return formattedDate;
}

export const formatProductAnalyticsTableDate = (date, period, startDate = null, endDate = null) => {
    let formattedDate = date;
    if(date) {
        let dateArr = date.split('');
        const year = date.substr(0, 4);
        let month = fullNameMonths[dateArr[1] - 1];
        const formattedPeriod = period ? period.toLowerCase() : '';
        switch(formattedPeriod) {
            case 'daily':
                dateArr = date.split('-');
                month = months[dateArr[1] - 1] ? months[dateArr[1] - 1] : '';
                const day = dateArr[2] ? dateArr[2] : '';
                formattedDate = `${month} ${day}, ${year}`;
                break;
            case 'weekly':
                let rangeDate = '';
                if(startDate && endDate) {
                    const startMonth = fullNameMonths[startDate.split('-')[1] - 1].substring(0,3);
                    const startDay = parseInt(startDate.split('-')[2], 10);
                    const startYear = parseInt(startDate.split('-')[0]);
                    const endMonth = fullNameMonths[endDate.split('-')[1] - 1 ].substring(0,3);
                    const endDay = parseInt(endDate.split('-')[2], 10);
                    const endYear = parseInt(endDate.split('-')[0]);
                    const isSameYear = startYear === endYear;
                    if(startMonth === endMonth) {
                        rangeDate = `${startMonth} ${startDay}-${endDay}, ${startYear}`;
                    } else {
                        rangeDate = `${startMonth} ${startDay}${!isSameYear ? `, ${startYear}` : ''} - ${endMonth} ${endDay}, ${endYear}`; 
                    }
                }
                dateArr = date.split(' ');
                const week = dateArr[2] ? dateArr[2] : '';
                formattedDate = `Week ${week}: ${rangeDate}`;
                break;
            case 'monthly':
                dateArr = date.split('-');
                month = fullNameMonths[dateArr[1] - 1] ? fullNameMonths[dateArr[1] - 1] : '';
                formattedDate = `${month} ${year}`;
                break;
            case 'quarterly':
                dateArr = date.split(' ');
                const quarterNo = dateArr[1] ? dateArr[1].substr(1,1) : '';
                formattedDate = `Q${quarterNo} ${year}: ${quarterMonths[quarterNo - 1] } ${year}`;
                break;
            default:
                break;
        }
    }
    return formattedDate;
}

// normal
export const chartTableColors = ['#09195b','#5a1b6c','#971a6e','#cc2965','#f34e52','#ff7e38','#ffb114','#ffe600']
export const getChartColorsSubset = (subsetSize) => {
    switch (subsetSize) {
        case 1:
            return [chartTableColors[0]]
        case 2:
            return [chartTableColors[0], chartTableColors[6]]
        case 3:
            return [chartTableColors[0], chartTableColors[5],chartTableColors[6]]
        case 4:
            return [chartTableColors[0], chartTableColors[2],chartTableColors[5],chartTableColors[6]]
        case 5:
            return [chartTableColors[0], chartTableColors[2],chartTableColors[5],chartTableColors[6],chartTableColors[7]]
        case 6:
            return [chartTableColors[0], chartTableColors[1],chartTableColors[3],chartTableColors[5],chartTableColors[6],chartTableColors[7]]
        case 7:
            return [chartTableColors[0],chartTableColors[2],chartTableColors[3],chartTableColors[4],chartTableColors[5],chartTableColors[6],chartTableColors[7]]
        case 8:
            return [chartTableColors[0], chartTableColors[1],chartTableColors[2],chartTableColors[3],chartTableColors[4],chartTableColors[5],chartTableColors[6], chartTableColors[7]]
    }
}
// high contrast order
// export const chartTableColors = ['#09195b','#ffb114','#ff7e38','#971a6e','#f34e52','#5a1b6c','#cc2965','#ffe600']
// export const getChartColorsSubset = (subsetSize) => {
//     switch (subsetSize) {
//         case 1:
//             return [chartTableColors[0]]
//         case 2:
//             return [chartTableColors[0], chartTableColors[1]]
//         case 3:
//             return [chartTableColors[0], chartTableColors[1],chartTableColors[2]]
//         case 4:
//             return [chartTableColors[0], chartTableColors[1],chartTableColors[2],chartTableColors[3]]
//         case 5:
//             return [chartTableColors[0], chartTableColors[1],chartTableColors[2],chartTableColors[3],chartTableColors[4]]
//         case 6:
//             return [chartTableColors[0], chartTableColors[1],chartTableColors[2],chartTableColors[3],chartTableColors[4],chartTableColors[5]]
//         case 7:
//             return [chartTableColors[0],chartTableColors[1],chartTableColors[2],chartTableColors[3],chartTableColors[4],chartTableColors[5],chartTableColors[6]]
//         case 8:
//             return [chartTableColors[0], chartTableColors[1],chartTableColors[2],chartTableColors[3],chartTableColors[4],chartTableColors[5],chartTableColors[6], chartTableColors[7]]
//     }
//
// }


//added green
// export const chartTableColors = ['#09195b','#5a1b6c','#971a6e','#cc2965','#ff7e38','#ffb114','#ffe600', '#1fc468']
// export const getChartColorsSubset = (subsetSize) => {
//     switch (subsetSize) {
//         case 1:
//             return [chartTableColors[0]]
//         case 2:
//             return [chartTableColors[0], chartTableColors[1]]
//         case 3:
//             return [chartTableColors[0], chartTableColors[5],chartTableColors[6]]
//         case 4:
//             return [chartTableColors[0], chartTableColors[2],chartTableColors[5],chartTableColors[6]]
//         case 5:
//             return [chartTableColors[0], chartTableColors[2],chartTableColors[5],chartTableColors[6],chartTableColors[7]]
//         case 6:
//             return [chartTableColors[0], chartTableColors[1],chartTableColors[3],chartTableColors[5],chartTableColors[6],chartTableColors[7]]
//         case 7:
//             return [chartTableColors[0],chartTableColors[2],chartTableColors[3],chartTableColors[4],chartTableColors[5],chartTableColors[6],chartTableColors[7]]
//         case 8:
//             return [chartTableColors[0], chartTableColors[1],chartTableColors[2],chartTableColors[3],chartTableColors[4],chartTableColors[5],chartTableColors[6], chartTableColors[7]]
//     }
// }


export const chartZAxisColor = '#5c79f0';
// export const revenueChartTableColors = ['#061240', '#FFE600', '#44aa99', '#e69f00', '#882255', '#ddcc77', '#332288', '#88ccee']
export const revenueChartZAxisColor = '#86dcaf';